export function openDialog (dialogId) {
  const dialog = document.getElementById(dialogId)
  dialog.setAttribute('data-open', 'true') // Set the dialog to open
  dialog.showModal() // Show the dialog
  dialog.addEventListener('keydown', closeOnEscape)
  dialog.addEventListener('click', closeOnClickOutside)
}

export function closeDialog (dialogId) {
  const dialog = document.getElementById(dialogId)
  dialog.removeAttribute('data-open') // Set the dialog to closed
  dialog.close() // Close the dialog

  // Remove event listeners when the dialog is closed
  dialog.removeEventListener('keydown', closeOnEscape)
  dialog.removeEventListener('click', closeOnClickOutside)
}

// Close modal on pressing the Escape key
function closeOnEscape (event) {
  const dialog = document.querySelector('dialog[data-open="true"]')
  const dialogId = dialog.getAttribute('id')
  if (event.key === 'Escape') {
    closeDialog(dialogId)
  }
}

// Close modal if clicking outside of the modal content
function closeOnClickOutside (event) {
  const dialog = document.querySelector('dialog[data-open="true"]')
  if (!dialog) {
    return
  }
  const dialogId = dialog.getAttribute('id')

  if (event.target === dialog) {
    closeDialog(dialogId)
  }
}



// WEBPACK FOOTER //
// ./src/utils/dialog.js